<template>
  <MoleculesWabunkaResponsiveDrawer :external-open-state="props.isOpen" :on-click="() => {}" @update:is-modal-open="updateDrawerOpen">
    <div class="bg-white">
      <div class="border-b border-gray-200 px-6 py-4">
        <h2 class="text-base font-normal leading-normal text-gray-700">{{ props.guestType.name }}</h2>
      </div>
      <div class="max-h-[70vh] overflow-y-auto px-6 py-6">
        <div class="space-y-4">
          <p class="whitespace-pre-wrap text-sm font-normal leading-tight text-gray-500">{{ props.guestType.description }}</p>
        </div>
      </div>
    </div>
  </MoleculesWabunkaResponsiveDrawer>
</template>

<script lang="ts" setup>
import type { WabunkaGuestTypeViewModel } from '@/wabunka-src/features/Experience/models/guestType';

interface Props {
  guestType: WabunkaGuestTypeViewModel;
  isOpen: boolean;
  onClose?: () => void;
}

const props = defineProps<Props>();

const updateDrawerOpen = (newVal: boolean) => {
  if (!newVal && props.onClose) {
    props.onClose();
  }
};
</script>
